import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/cart/InquiryCartClient.tsx");
